module.exports = __webpack_public_path__ + "static/media/dropbox.5178205b.svg";